import { cn } from '@utils/cn';
import type { ReactNode } from 'react';
import type { FieldPath, FieldValues, FormState, Message } from 'react-hook-form';

export function FormErrorMessage<
  TValues extends FieldValues = FieldValues,
  TName extends FieldPath<TValues> = FieldPath<TValues>,
>({
  name,
  formState,
  children,
  className,
}: {
  name: TName;
  formState: FormState<TValues>;
  children?: ReactNode;
  className?: string;
}) {
  const errors = formState.errors?.[name]?.message as Message | null;
  const body = errors ? errors : children;
  if (!body) return null;
  return <p className={cn(className, 'text-xs text-destructive')}>{body}</p>;
}
